import PoolSettingsCard from "./PoolSettingsCard";

export default PoolSettingsCard;
